<template>
  <div class="myssl-top mb-5">
    <div class="top-writing writing-book mt-5">
      <div class="book-container" style="display: flex; justify-content: space-evenly">
<!--      <swiper-->
<!--          class="book-container"-->
<!--          :class="{'ssl-one-items': items.length === 1}"-->
<!--          :loop="false"-->
<!--          slides-per-view="auto"-->
<!--          :centered-slides="false"-->
<!--          :space-between="items.length === 1 ? 0 : 28"-->
<!--          :slides-offset-before="items.length === 1 ? 0 : 28"-->
<!--          :slides-offset-after="items.length === 1 ? 0 : 28"-->
<!--      >-->
        <div v-for="(item, idx) in items"  class="book-item" :key="idx">
<!--        <swiper-slide v-for="(item, idx) in items"  class="book-item" :key="idx">-->

<!--            <span v-if="!item.isFree">p.-->
<!--              <text>{{item.currentPage}}</text>-->
<!--              / {{item.totalPage}}-->
<!--            </span>-->

<!--          <div v-if="!item.isFree" class="book-mark" :style="{ left: item.percentage * 86 / 100 + '%'}">-->
<!--            <img src="@/assets/lxp/images/ssl/myssl/bookmark.png"/>-->
<!--          </div>-->
<!--          <div v-if="!item.isFree" class="progress mb-4" style="width: 140px; margin-left: 0px; position: absolute; z-index: 2;">-->
<!--            <div class="progress-bar" style="background-color: rgb(101 162 255)" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" :style="{ width: item.percentage + '%'}"></div>-->
<!--          </div>-->

          <div v-if="item.isFree" class="book">
            <a href="javascript:" class="book-link"></a>
            <div class="book-cover">
              <img src="@/assets/lxp/mobile/images/ssl/myssl/img_book_kb.jpg" alt="" />
            </div>
            <div class="book-content">
              <span class="content-author">-</span>
              <span class="content-title">자유도서</span>
            </div>
          </div>

          <div v-else class="book">

            <a href="javascript:" class="book-link"></a>
            <div class="book-cover">
              <img :src="item.thumb" alt="" />
<!--              <div v-if="lrner == null" class="record-book">-->
<!--&lt;!&ndash;                <i @click="openTimerModal(idx)" class="icon-progress" style="border-right:2px solid #454138;"></i>&ndash;&gt;-->
<!--                <i @click="openMemoModal(idx)" class="icon-symbol"></i>-->
<!--              </div>-->
            </div>
            <div class="book-content">
              <span class="content-author">{{ item.bookDesc }}</span>
              <span class="content-title text-skip">{{ item.bookNm }}</span>
            </div>


          </div>
          <router-link v-if="showWriteButton" :to="{name: 'SSLWrite', params: {distCrseCd:'book', lrnTrgtGrpMstSn:bookTgmSn, socLrnPostSn: 0}, query:{relSn: item.bookIsbn, mltgms:Date.now()}}" class="kb-btn-writing">
            <span class="text">글쓰기</span>
            <i class="icon-writing"></i>
          </router-link>
        </div>
<!--        </swiper-slide>-->
<!--      </swiper>-->
      </div>
      </div>
  </div>

<!--  <div class="section-wrapper">-->
<!--    <article class="myssl-section section-myactivity">-->
<!--      <header class="section-header">-->
<!--        <h4 class="title">독서 루틴 <button class="tool-tip-button" @click="tooltip = !tooltip"><img src="@/assets/lxp/images/common/ic_tooltip.svg" alt=""></button></h4>-->
<!--        <div class="tool-tip" :class="{'is-active': tooltip}" style="top:-10px; width: 100%">-->
<!--          <div class="tool-tip-desc">-->
<!--            나의 독서 루틴을 확인할 수 있는 지표입니다. <span style="color:rgb(255,0,0);">(수료 및 평가에 반영되지 않습니다.)</span><br>-->
<!--            - 독서시간: 도서 표지 이미지 우측 하단의 '독서 타이머'를 통해 기록된 독서시간의 합입니다.<br>-->
<!--            - 독서일수: 독서 타이머를 실행한 일수입니다.<br>-->
<!--            - 독서메모: 독서 메모 작성건수입니다.<br>-->
<!--            - 완료: 도서 표지 이미지 상단에 기록한 페이지수 기준으로 완료된 신청도서 권수입니다.<br>-->
<!--          </div>-->
<!--        </div>-->
<!--      </header>-->
<!--      <div class="symbol-item-wrap" data-content="row">-->
<!--        <template v-for="(item, idx) in actItems" :key="idx">-->
<!--          <SymbolBookRoutineCard :title="item.title" :type="item.type" :data="item.data" :show-detail="item.showDetail" :func="item.func" :is-mobile="isMobile" />-->
<!--        </template>-->
<!--      </div>-->
<!--    </article>-->
<!--  </div>-->
</template>
<script>
// import SSLMyTimerModal from "@/components/ssl/my/SSLMyTimerModal.vue";
// import SSLMyMemoModal from "@/components/ssl/my/SSLMyMemoModal.vue";
// import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
import {sslMyBookSetup} from "@/assets/js/modules/ssl/setup/ssl-my-setup";
// import SymbolBookRoutineCard from "@/components/history/module/SymbolBookRoutineCard.vue";

export default {
name: 'SSLMyBook',
props:{
  focusFunc: Object,
  bookTgmSn: Number
},
components: {
  // SymbolBookRoutineCard,
// SSLMyTimerModal,
// SSLMyMemoModal,
// Swiper,
// SwiperSlide,
},
setup: sslMyBookSetup
}
</script>